// ImageContext.js
import { createContext, useState, useEffect } from "react";

export const ExportImageContext = createContext();

export const ExportImageProvider = ({ children }) => {
  const [imageData, setImageData] = useState(null);
  // Optional: Load from localStorage (persistent caching)
  useEffect(() => {
    const stored = localStorage.getItem("cachedImage");
    if (stored) setImageData(stored);
  }, []);

  // Save to localStorage whenever it changes
  useEffect(() => {
    if (imageData) localStorage.setItem("cachedImage", imageData);
  }, [imageData]);

  const downloadAndSaveImage = async (urlBlob) => {
    try {
      const base64 = await convertBlobToBase64(urlBlob);
      setImageData(base64);
    } catch (error) {
      console.error("Error downloading and saving image:", error);
    }
  };

  const convertBlobToBase64 = (blob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });

  return (
    <ExportImageContext.Provider value={{ imageData, downloadAndSaveImage }}>{children}</ExportImageContext.Provider>
  );
};
